import React from 'react';
import { Navigate } from 'react-router-dom';
import { useClientAuth } from '../context/ClientAuthContext';

const ClientAuthGuard = ({ element: Component }) => {
    const { isAuthenticated, role } = useClientAuth();


    if (isAuthenticated) {
        // Redirect based on user role
        switch (role) {
            case 'Client':
                return <Navigate to="/Client/dashboard/Client_home" />;
            default:
                return <Navigate to="/Client" />;
        }
    }

    return <Component />;
};
export default ClientAuthGuard;
